import { inputs } from '@ecosystem/newron-design-system';

export const WithMonthRangePicker = ({ defaultDates, onChange, ...otherProps }) => {
  const { MonthPicker, MonthFormatType } = inputs;

  return (
    <div data-testid="with-month-range-picker">
      <MonthPicker
        isRange={true}
        defaultDates={defaultDates}
        onChange={onChange}
        dateFormat={MonthFormatType['MMM yyyy']}
        primaryPlaceholder="Month Year"
        secondaryPlaceholder="Month Year"
        {...otherProps}
      />
    </div>
  );
};
